import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { AssetRequest } from '../models/dto/asset-request';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';



@Injectable({
  providedIn: 'root'
})


export class AssetService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { 
  }
  
  assetsGet(
      assetCode?            : string,
      withLinkedData?       : boolean,
      serialNumber?         : string,
      barCode?              : string,
      assetOrderCode?       : string, 
      branchCode?           : string,
      assetProductCategoryCode?  : string,
      assetProductCode?          : string,
      partnerCode?          : string,
      partnerSiteCode?      : string,
      assetStatusCode?      : string,
      assetTransferCode?    : string,
      withPendingTickets?   : boolean,
      withoutPendingTickets?: boolean,
      includeClosed?        : boolean,
      ): Promise<Asset[]> {
      let request: AssetRequest = new AssetRequest(this.userService.userInfo);

      request.asset.assetCode			        = assetCode;
      request.asset.serialNumber			    = serialNumber;
      request.asset.barCode			            = barCode;
      request.asset.assetOrderCode			    = assetOrderCode;
      request.asset.branch.branchCode           = branchCode;
      request.asset.assetProduct.assetProductCode  = assetProductCode;
      request.asset.assetProduct.assetProductCategory.assetProductCategoryCode = assetProductCategoryCode;
      request.asset.partner.partnerCode         = partnerCode
      request.asset.partnerSite.partnerSiteCode = partnerSiteCode
      //request.asset.assetCategory.assetCategoryCode=
      //request.asset.assetCategoryType.assetCategoryCode=
      request.asset.assetStatusCode = assetStatusCode;
      request.assetTransferCode                 = assetTransferCode;
      request.withLinkedData                    = withLinkedData;
      request.withPendingTickets                = withPendingTickets;
      request.withoutPendingTickets             = withoutPendingTickets;
      request.includeClosed                     = includeClosed;

      return new Promise((resolve, reject) => {
          this.networkService.post('kernel/masters/assetsGet', request).then(result => {
              return resolve(result.assets);
              
          }, error => {
              reject(error);
          });
      });
  }



assetGet(code : string, serialNumber : string, withLinkedData : boolean): Promise<Asset> {

    let request: AssetRequest = new AssetRequest(this.userService.userInfo);

    request.asset.assetCode	    = code;
    request.asset.serialNumber  = serialNumber;
    request.withLinkedData      = withLinkedData;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/assetsGet', request).then(result => {
            return resolve(result.asset);
            
        }, error => {
            reject(error);
        });
    });
}


  assetSave(asset : Asset) : Promise<Asset>{
    let request: AssetRequest = new AssetRequest(this.userService.userInfo);
    request.asset = asset;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/assetSave', request).then(result => {
            let asset : Asset ;
            if (result.assets) {
              asset = result.assets[0];
            }
            return resolve(asset);  
        }, error => {
            reject(error);
        });
    });
  }

    
   //-----------------------------------------------------------------------------------------------------
   assetClose(assetCode : string) : Promise<Asset> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    
    request.code = assetCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/masters/assetClose', request).then(result => {
          return resolve(result.asset);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------

/*
  setBarcode(assetCode : string, barCode : string) : Promise<boolean>{
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = assetCode;
    request.strArg2 = barCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetBarCodeSet', request).then(result => {
            return resolve(true);  
        }, error => {
            reject(error);
        });
    });
  }
*/

assetBarCodeSet(assetCode : string, barCode : string) : Promise<Boolean>{
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = assetCode;
    request.strArg2 = barCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetBarCodeSet', request).then(result => {
            return resolve(result.blnArg1);
            
        }, error => {
            reject(error);
        });
    });
}

getGeoAreaKpis(assetCode : string) : Promise<GeoArea>{
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = assetCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/geoAreaKpis', request).then(result => {
            return resolve(result.geoArea);
            
        }, error => {
            reject(error);
        });
    });
}
}

